export default "__VITE_ASSET__0f08f2f6__"